var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagsX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x92\x8E Icon=Tags, Stroke=2.0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.134 20.9971L21.1068 13.0242C21.4825 12.6486 21.6933 12.1389 21.6926 11.6076L21.6855 5.73473C21.6848 5.18245 22.132 4.73419 22.6843 4.73351C23.2365 4.73284 23.6848 5.18001 23.6855 5.7323L23.6926 11.6052C23.6939 12.6677 23.2724 13.6871 22.521 14.4385L14.5482 22.4113C14.1577 22.8018 13.5245 22.8018 13.134 22.4113C12.7435 22.0208 12.7435 21.3876 13.134 20.9971Z",
    className: "Icon-fill-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7164 9.16718C13.4974 9.94823 14.7638 9.94823 15.5448 9.16718C16.3259 8.38613 16.3259 7.1198 15.5448 6.33875C14.7638 5.5577 13.4974 5.5577 12.7164 6.33875C11.9353 7.1198 11.9353 8.38613 12.7164 9.16718Z",
    className: "Icon-fill-color"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9168 11.0578C20.9115 11.8464 20.5958 12.6012 20.0382 13.1589L12.2232 20.9738C11.0517 22.1454 9.15218 22.1454 7.98061 20.9738L1.24196 14.2352C0.0703895 13.0636 0.0703868 11.1641 1.24196 9.99251L9.06645 2.16802C9.6156 1.61887 10.3563 1.30408 11.1328 1.28985L17.9083 1.16568C19.5943 1.13478 20.9746 2.49915 20.9632 4.18542L20.9168 11.0578ZM18.624 11.7446C18.8099 11.5588 18.9151 11.3072 18.9169 11.0443L18.9632 4.17192C18.967 3.60983 18.5069 3.15504 17.9449 3.16534L11.1694 3.28951C10.9106 3.29425 10.6637 3.39918 10.4807 3.58224L2.65617 11.4067C2.26565 11.7972 2.26565 12.4304 2.65617 12.8209L9.39482 19.5596C9.78534 19.9501 10.4185 19.9501 10.809 19.5596L18.624 11.7446Z",
    className: "Icon-fill-color"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsX2);
export default __webpack_public_path__ + "static/media/TagsX2.ece3f97c6dcc2cba059d2e94d2744e92.svg";
export { ForwardRef as ReactComponent };